import {CLOSE_BUTTON, CLOSE_NAV_BAR} from "../actions/actionTypes";

const buttonClosed = (state = true, action) => {
    switch (action.type) {
        case CLOSE_BUTTON:
            return !action.buttonClosed;
        case CLOSE_NAV_BAR:
            return true;
        default:
            return state;
    }
};

export default buttonClosed;



// WEBPACK FOOTER //
// ./src/reducers/button.js